// extracted by mini-css-extract-plugin
export default {"moreOptionsMultisku":"_594bb9c5"};